import axios from 'axios';

export const createAxiosClient = (instance) => {
  const DefaultHeaders = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json;charset=UTF-8',
    Authorization: instance,
  };

  return axios.create({
    headers: DefaultHeaders,
  });
};
